import React, { useState,useEffect } from 'react';
import { ToggleLabel, ToggleInput, ToggleSlider, ToggleSliderBefore } from './styles';

export const Toggle = ({ checked, onChange }) => {
  const [isToggled, setIsToggled] = useState(checked);

  const handleToggle = () => {
    setIsToggled(!isToggled);
    onChange(!isToggled);
  }

  useEffect(() => {
    setIsToggled(checked);
  }, [checked])

  return (
    <ToggleLabel>
      <ToggleInput checked={isToggled} onChange={handleToggle} />
      <ToggleSlider checked={isToggled}>
        <ToggleSliderBefore checked={isToggled} />
      </ToggleSlider>
    </ToggleLabel>
  )
}

